import React, { useState, useContext, useEffect }  from 'react'
import { Button ,Form , Row, Col} from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import "./FAQcreate.css"
import { createfaq } from "../Network/FAQ"
import { HeaderTitle } from '../Library'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { setDocumentTitle } from '../AppTitle'

function FAQcreate() {
    const history = useHistory();
    const langCx = useContext(LanguageContext);
    const lang1 = langCx.lang.FAQ;
    const langError = langCx.lang.error;
    const notifyCx = useContext(NotifyContext);

    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [isError, setError] = useState(false);


    const onSubmit = () =>{
        if( !question || !answer ){ 
            notifyCx.showNotify(lang1.not_complete, lang1.not_complete_desc, 1)
            setError(true);
            return;
        }

        setLoading(true);
        createfaq(
            question,
            answer,
            ()=>{
                setLoading(false)
                notifyCx.showNotify(
                    lang1.created_faq,
                    lang1.complete_desc,
                    0)
                history.goBack()
            },
            (error)=>{
                setLoading(false)
                notifyCx.showNotify("Error", error.message, 2)
            }
        )
    }
    
    useEffect(()=>{
        setDocumentTitle("Create FAQ")
    },[])
   
    return (
    
        <div id="faqcreate">
            <HeaderTitle title={lang1.add_faq} isShowBack backTo="/faq"/>
                <Row style={{width: "100%"}}>
                    <Col className="content-container" md={10} lg={8} xl={6}>
                        <Form
                            onSubmit={(e)=>{
                                e.preventDefault();
                                onSubmit();
                            }}
                        >
                            <Form.Label  className = "Question-label">{lang1.question}</Form.Label>
                            <Form.Control 
                                className = "Question-form" 
                                value={question}
                                isInvalid={isError && !question}
                                onChange={(e)=>setQuestion(e.target.value)} 
                            />
                            <Form.Label className = "Answer-label">{lang1.answer}</Form.Label>
                            <Form.Control className = "Answer-form" 
                                value={answer}
                                isInvalid={isError && !answer}
                                onChange={(e)=>setAnswer(e.target.value)} />
                            <Button type="submit" className = "add-button">
                                {lang1.add_button} 
                            </Button>
                        </Form>
                    </Col>
                </Row>
        </div>
    )
}

export default FAQcreate